const env = process.env

export function getEnv(key, targetType) {
  const value = env[key] || ''
  if (!targetType) {
    targetType = 'string'
  }
  switch (targetType.toLowerCase()) {
    case 'boolean':
      return value==='true'
    case 'number':
      return Number(value)
    case 'string':
    default:
      return value
  }
}

export function check(key) {
  return !!env[key]
}

function install(Vue) {
  Vue.prototype.$env = getEnv
  Vue.prototype.$checkEnv = check
}

export default {
  getEnv,
  check,
  install
}
